export enum UserDefinitionWindowKinds {
  Normal = 1,
  Institution = 2,
}
